module.exports = __webpack_public_path__ + "static/media/covi_too_all_too.351d3f96.png";